const API = {
  GET_FETCH_SESSION_SUMMARY: {
    path: '/session/summary',
    method: 'GET',
  },
  GET_SESSION_CERTIFICATES: {
    path: '/certificates/session/:sessionId',
    method: 'GET',
  },
  EXPORT_SESSION_CERTIFICATES: {
    path: '/certificates/session/:sessionId/export',
    method: 'GET',
  },
  GET_SESSION_URL: {
    path: '/meeting/generate-signed-url',
    method: 'POST',
  },
  ISSUE_SESSION_CERTIFICATE: {
    path: '/certificates/issue/:sessionId',
    method: 'POST',
  },
  BULK_ISSUE_SESSION_CERTIFICATE: {
    path: '/certificates/session/bulk/:sessionId',
    method: 'POST',
  },
  POST_UPDATE_SESSION: {
    path: '/session/update',
    method: 'POST',
  },
  DELETE_DELETE_SESSION: {
    path: '/session/delete',
    method: 'DELETE',
  },
  POST_CREATE_SUPPORT_FEEDBACK: {
    path: '/feedback/create',
    method: 'POST',
  },
};
export default API;
